module.exports = __webpack_public_path__ + "static/media/sample_bulk_mark_rso.b37a021a.csv";